import { ALBERTA_SITE_URL } from '@/constants/constants';

type SiteOrigin = 'roc' | 'ont';

const ROC_BTAGS: Record<string, string> = {
  returningUser: '671111',
  loggedIn: '672222',
};

const UTM_SOURCES: Record<SiteOrigin, string> = {
  roc: 'LD+ROC+AB+IP',
  ont: 'ONT+AB+IP',
};

export function getAlbertaRedirectUrl(
  site: SiteOrigin,
  isAuthenticated: boolean,
  isReturningUser: boolean,
): string {
  if (site === 'roc' && isAuthenticated) {
    return `${ALBERTA_SITE_URL}?btag=${ROC_BTAGS.loggedIn}`;
  }
  if (site === 'roc' && isReturningUser) {
    return `${ALBERTA_SITE_URL}?btag=${ROC_BTAGS.returningUser}`;
  }
  return `${ALBERTA_SITE_URL}?utm_source=${UTM_SOURCES[site]}&utm_medium=new+user%2C+no+cookie`;
}

/**
 * Navigate to a site outside this SPA (LP-1164).
 *
 * The iOS app wrapper opens user-tapped link navigations in an un-closable
 * popup webview, but allows JS-initiated navigations (see the locale redirect
 * in useUserLocaleRedirect). Call this from an <a> onClick after
 * preventDefault() so the main webview navigates instead.
 */
export function redirectToExternalSite(url: string): void {
  try {
    if (window.top && window.top !== window.self) {
      // If the wrapper embeds the site in an iframe, navigate the top frame.
      window.top.location.href = url;
      return;
    }
  } catch {
    // Cross-origin top frame denied access — fall back to same-frame navigation.
  }
  window.location.assign(url);
}
